import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Stock, StockCreate, StockFilter } from '../data/stock';

export function createStockService(client: AxiosInstance) {
  return createCrudService<Stock, StockCreate, StockFilter>(client, '/Stock', 'stockId');
}

export type StockService = CrudService<Stock, StockCreate, StockFilter>;
